import Link from "next/link";
import React from "react";
import { storyblokEditable } from "@storyblok/react";

const ServiceSlider = ({ blok }) => (
  <div className="wrap">
    <div className="inner-wrap" {...storyblokEditable(blok)}>
      <div className="service-slider-allcontent flex justify-between">
        <div className="service-slider-content flex flex-col ">
          <h2 className="text-2xl">{blok.subheadline1}</h2>
          <div className="service-slider-image-wrap">
            <Link href={blok.link1} >
              <img src={blok.image1.filename} alt={blok.image1.alt} />
            </Link>
          </div>
          <p>{blok.infotext1}</p>
        </div>

        <div className="service-slider-content flex flex-col ">
          <h2 className="text-2xl">{blok.subheadline2}</h2>
          <div className="service-slider-image-wrap">
            <Link href={blok.link2} >
              <img src={blok.image2.filename} alt={blok.image2.alt} />
            </Link>
          </div>

          <p>{blok.infotext2}</p>
        </div>

        <div className="service-slider-content flex flex-col ">
          <h2 className="text-2xl">{blok.subheadline3}</h2>
          <div className="service-slider-image-wrap">
            <Link href={blok.link3} >
              <img src={blok.image3.filename} alt={blok.image3.alt} />
            </Link>
          </div>
          <p>{blok.infotext3}</p>
        </div>
      </div>
    </div>
  </div>
);

export default ServiceSlider;
